"use client";

import { SidebarItem } from "./NewsSidebarClient";

const start_year = 2016;

export default function YearItem() {
  const current_year = new Date().getFullYear();
  const arr_to_year = new Array(current_year - start_year + 1)
    .fill(0)
    .map((_, i) => start_year + i);
  const years = {} as Record<number, string>;
  for (const i of arr_to_year) {
    years[i] = i.toString();
  }

  return (
    <SidebarItem
      name="Archive"
      internal_name="year"
      items={years}
    />
  );
}
